
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50/30">
      <Header />
      <Hero />
      <Services />
      <WhyChooseUs />
      <CTA />
      <Footer />
    </div>
  );
}